import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ClientSaleOrderService} from 'app/blocks/service/api/client-sale-order.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IClientSaleOrder} from 'app/blocks/model/client-sale-order.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {ClientSaleOrder} from 'app/blocks/model/client-sale-order.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ClientSaleOrderResource extends AbstractEntityResource<IClientSaleOrder> {
    constructor(clientSaleOrderService: ClientSaleOrderService, router: Router) {
        super(
            Resource.CLIENT_SALE_ORDERS,
            clientSaleOrderService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CLIENT_SALE_ORDERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CLIENT_SALE_ORDERS),
            (entity?) => new ClientSaleOrder(entity),
            (entity) => entity.saleOrderNo,
            'shopping_cart'
        );
    }
}
